// import { apiURL } from "../../utils/config";

import { apiURL } from "../../utlis/config";
// import { apiURL } from "utlis/config";
import $ from "jquery";
import store from "store";
//updateMyCartTraining
var Actions = {
  memberProfileUpdate: (file) => {
    return new Promise((resolve, reject) => {
      var form = new FormData();
      form.append("image", file);
      // form.append("name", query.get('name'))
      // form.append("description", query.get('description'))
      var settings = {
        async: true,
        crossDomain: true,
        url: `${apiURL}/staffMember/profile`,
        method: "POST",
        processData: false,
        contentType: false,
        mimeType: "multipart/form-data",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: form,
        success: function (response) {
          resolve(JSON.parse(response));
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            store.clearAll();
            window.location.reload();
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },
  memberPasswordUpdate: (data) => {
    return new Promise((resolve, reject) => {
      var settings = {
        async: true,
        crossDomain: true,
        url: `${apiURL}/password/reset`,
        method: "PUT",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: data,
        success: function (response) {
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            store.clearAll();
            window.location.reload();
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },
  memberInfoUpdate: (data) => {
    return new Promise((resolve, reject) => {
      var settings = {
        async: true,
        crossDomain: true,
        url: `${apiURL}/staffMember`,
        method: "PUT",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: data,
        success: function (response) {
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            store.clearAll();
            window.location.reload();
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },
  memberInfoUpdate2: (data, method) => {
    return new Promise((resolve, reject) => {
      var settings = {
        async: true,
        crossDomain: true,
        url: `${apiURL}/staffMember`,
        method: method,
        data: data,
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        success: function (response) {
          if (response.error) {
            resolve(response);
          } else {
            resolve(response);
          }
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            store.clearAll();
            window.location.reload();
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };

      $.ajax(settings).done();
    });
  },
};

export default Actions;
